import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials: true → il cookie httpOnly `fabri_token` (login classico) e
// `session_token` (Google OAuth) viaggiano automaticamente.
export const api = axios.create({ baseURL: API, withCredentials: true, timeout: 30000 });

// --- Retry policy per 502/503/504 e errori di rete (solo letture) ---
const MAX_RETRIES = 3;
const RETRY_STATUSES = [502, 503, 504];
let networkWarnShown = false;

const isReadOnly = (cfg) => {
  const m = (cfg?.method || "get").toLowerCase();
  return m === "get" || m === "head";
};

const delay = (ms) => new Promise((r) => setTimeout(r, ms));

api.interceptors.response.use(
  (r) => {
    // Reset del warning se una chiamata va a buon fine
    networkWarnShown = false;
    return r;
  },
  async (err) => {
    const cfg = err?.config || {};
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail || "";

    // Hard errors prima
    if (status === 401) {
      try { localStorage.removeItem("fabri_user"); localStorage.removeItem("fabri_token"); } catch { /* no-op */ }
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/login")) {
        window.location.replace("/login");
      }
      return Promise.reject(err);
    }
    if (status === 403 && /setup account/i.test(detail)) {
      try { localStorage.removeItem("fabri_user"); } catch { /* no-op */ }
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/setup") && !window.location.pathname.startsWith("/login")) {
        window.location.replace("/setup");
      }
      return Promise.reject(err);
    }
    if (status === 403) {
      // Permessi insufficienti: non blocca la UI
      try { toast.error(detail || "Non hai i permessi per questa sezione"); } catch { /* no-op */ }
      return Promise.reject(err);
    }

    // Retry su 5xx/network solo per GET/HEAD
    const noResponse = !err?.response;        // errore di rete puro
    const isRetryStatus = status && RETRY_STATUSES.includes(status);
    if ((noResponse || isRetryStatus) && isReadOnly(cfg)) {
      cfg.__retryCount = (cfg.__retryCount || 0) + 1;
      if (cfg.__retryCount <= MAX_RETRIES) {
        if (!networkWarnShown) {
          networkWarnShown = true;
          try { toast.loading("Connessione momentanea assente, riprovo…", { id: "net-retry" }); } catch { /* no-op */ }
        }
        await delay(500 * Math.pow(2, cfg.__retryCount - 1));  // 500, 1000, 2000 ms
        try {
          const r = await api.request(cfg);
          try { toast.dismiss("net-retry"); } catch { /* no-op */ }
          networkWarnShown = false;
          return r;
        } catch (e) {
          // continua a propagare
        }
      }
      try { toast.dismiss("net-retry"); toast.error("Servizio non raggiungibile, riprova tra poco"); } catch { /* no-op */ }
    } else if (status && status >= 500) {
      try { toast.error("Errore del server, riprova tra poco"); } catch { /* no-op */ }
    }
    return Promise.reject(err);
  }
);

// Promise rejections non catturate → log centralizzato, niente overlay rosso
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (ev) => {
    const r = ev.reason;
    // axios errors sono già gestiti dall'interceptor; silenzia il resto in console-only
    try {
      // eslint-disable-next-line no-console
      console.warn("[unhandledrejection]", r?.message || r);
      ev.preventDefault();  // evita l'overlay rosso di react-error-overlay
    } catch { /* no-op */ }
  });
}
